import BaseService from "../BaseService";
import _ from "lodash";

class OrderService extends BaseService {
    list = async (filter) => {
        var data = await this._api.post("/order/list",filter);
        return data;
    };

    get = async ({ id } = {}) => {
        var data = await this._api.post("/order/get", { id });
        return data;
    };

    create = async (order) => {
        var data = await this._api.post("/order/create", order);
        return data;
    };


    update = async (order) => {
        var data = await this._api.post("/order/update", order);
        return data;
    };



    createInvoiceFile = async ({ id } = {}) => {
        var data = await this._api.post("/order/create_invoice", { id });
        return data;
    };

    createPackingListFile = async ({ id } = {}) => {
        var data = await this._api.post("/order/create_packinglist", { id });
        return data;
    };
    createPickingListFile = async ({ ids } = {}) => {
        var data = await this._api.post("/order/create_pickinglist", { ids });
        return data;
    };


    


    createShippingLabelFile = async ({ id } = {}) => {
        var data = await this._api.post("/order/create_shippinglabel", { id });
        return data;
    };



    cancel = async ({ id, reason } = {}) => {
        var data = await this._api.post("/order/cancel", { id, reason });
        return data;
    };

    finish = async ({ id, note } = {}) => {
        var data = await this._api.post("/order/finish", { id, note });
        return data;
    };












}
export default OrderService;
